import { IMask } from "react-imask";

// Formata um número como moeda brasileira
export const formatCurrency = (
  value: number,
  showCents: boolean = true,
  showSymbol: boolean = true
): string => {
  const hasCents = value % 1 !== 0;

  return new Intl.NumberFormat('pt-BR', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: 'BRL',
    minimumFractionDigits: showCents || hasCents ? 2 : 0,
    maximumFractionDigits: showCents || hasCents ? 2 : 0,
  }).format(value);
};

// Formata o código da comanda
export const formatCartId = (value: number | null | undefined): string => {
    if (!value) return '';
    const stringValue = value.toString();
    return stringValue.length > 4 ? stringValue.slice(-4) : stringValue;
};

// Formata CPF
export const formatCpf = (value: string | null | undefined): string => {
  if (!value) return '';
  const cpfMask = IMask.createMask({
    mask: '000.000.000-00',
  });
  cpfMask.resolve(value);
  return cpfMask.value;
};

// Formata CEP
export const formatZipcode = (value: string | null | undefined): string => {
  if (!value) return '';
  const zipcodeMask = IMask.createMask({
      mask: '00000-000',
  });
  zipcodeMask.resolve(value);
  return zipcodeMask.value;
};

// Formata telefone
export const formatPhone = (phoneNumber: string): string => {
  const cleanPhoneNumber = phoneNumber.replace(/\D/g, '');

  // Verifica se possui DDI (mais de 11 dígitos normalmente indica isso)
  const hasDDI = cleanPhoneNumber.length > 11;

  let mask: string;

  if (hasDDI && cleanPhoneNumber.startsWith('55')) {
    // Número brasileiro com DDI
    const isMobile = cleanPhoneNumber[4] === '9'; // após +55 (2) + DDD (2)
    mask = '+00 (00) ' + (isMobile ? '00000-0000' : '0000-0000');
  } else if (hasDDI) {
    // Número internacional sem ser Brasil
    // Gera uma máscara do tipo: +00 0000... até o fim dos dígitos
    const countryCodeLength = 2; // ajuste se quiser detectar dinamicamente
    const restLength = cleanPhoneNumber.length - countryCodeLength;
    const restMask = '0'.repeat(restLength);
    mask = '+00 ' + restMask;
  } else {
    // Número nacional sem DDI
    const isMobile = cleanPhoneNumber[2] === '9';
    mask = (isMobile ? '(00) 00000-0000' : '(00) 0000-0000');
  }

  const phoneMask = IMask.createMask({ mask });
  phoneMask.resolve(cleanPhoneNumber);

  return phoneMask.value;
};


// Formata distância
export const formatDistance = (distance: number): string => {
  if (distance >= 1) {
    // Distância em quilômetros com duas casas decimais
    return `${distance.toFixed(2)} km`
  } else {
    // Distância em metros com três casas decimais
    const distanceInMeters = distance * 1000
    return `${distanceInMeters} m`
  }
}


// Formata current_address
export const formatCurrentAddress = (values: any, short: boolean = false): string => {
  if (!values || typeof values !== "object") return "";

  // Quando for short, retorna apenas Rua + número
  if (short) {
    const street = values.street || "";
    const number = values.number ? values.number : "s/n";
    return `${street}, ${number}`.trim();
  }

  // Formato completo
  const streetWithNumberAndComplement = (() => {
    const street = values.street || "";
    const number = values.number ? values.number : "s/n";
    const complement = values.complement ? ` / ${values.complement}` : "";
    return `${street}, ${number}${complement}`;
  })();

  const cityState = values.city
    ? values.state
      ? `${values.city} - ${values.state}`
      : values.city
    : values.state || null;

  const fields = [
    streetWithNumberAndComplement,
    values.neighborhood,
    cityState,
    values.zipcode ? `CEP: ${formatZipcode(values.zipcode)}` : null,
  ];

  const formatted = fields
    .filter(Boolean)
    .map((field) => field.toString().trim())
    .join(", ");

  return values.reference
    ? `${formatted} (referência: ${values.reference.trim()})`
    : formatted;
};